import { tradeApi } from '@lib/axios';
import { apiCall } from './api-utils';

const BASE = '/v1';

export const getUserProfile = () =>
  apiCall(() => tradeApi.get(`${BASE}/user-profile`), 'getUserProfile');

export const getUserActivity = (to, from, source) =>
  apiCall(
    () => tradeApi.get(`${BASE}/user/activity`, { params: { to, from, source } }),
    'getUserActivity',
  );

export const getSubscriptions = () =>
  apiCall(() => tradeApi.get(`${BASE}/subscription-payments`), 'getSubscriptions');

export const getReferralEarnings = () =>
  apiCall(() => tradeApi.get(`${BASE}/referral-earnings`), 'getReferralEarnings');